<template>
  <nav class="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 py-2 px-4 flex justify-around items-center shadow-lg z-10">
    <!-- Dashboard - Visible for all roles -->
    <router-link to="/dashboard" class="flex flex-col items-center text-xs relative group" active-class="text-[#E9041D]" exact-active-class="text-[#E9041D]">
      <div class="p-2 rounded-full transition-colors group-hover:bg-gray-100">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
        </svg>
      </div>
      <span class="mt-1 font-medium">Dashboard</span>
      <div class="absolute -top-1 -right-1 w-2 h-2 bg-[#E9041D] rounded-full" v-if="$route.path === '/dashboard'"></div>
    </router-link>
    
    <!-- Checks - Only visible for checker role -->
    <router-link v-if="showChecks" to="/checks/start" class="flex flex-col items-center text-xs relative group" active-class="text-[#E9041D]" exact-active-class="text-[#E9041D]">
      <div class="p-2 rounded-full transition-colors group-hover:bg-gray-100">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
        </svg>
      </div>
      <span class="mt-1 font-medium">Check</span>
      <div class="absolute -top-1 -right-1 w-2 h-2 bg-[#E9041D] rounded-full" v-if="$route.path.startsWith('/checks')"></div>
    </router-link>
    
    <!-- Fahrten - Only visible for driver role -->
    <router-link v-if="showDrives" to="/drives" class="flex flex-col items-center text-xs relative group" active-class="text-[#E9041D]" exact-active-class="text-[#E9041D]">
      <div class="p-2 rounded-full transition-colors group-hover:bg-gray-100">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 4H5a2 2 0 00-2 2v12a2 2 0 002 2h14a2 2 0 002-2V6a2 2 0 00-2-2zM16 2v4M8 2v4M3 10h18" />
        </svg>
      </div>
      <span class="mt-1 font-medium">Fahrten</span>
      <div class="absolute -top-1 -right-1 w-2 h-2 bg-[#E9041D] rounded-full" v-if="$route.path.startsWith('/drives')"></div>
    </router-link>
    
    <!-- Schlüsselübergabe - Only visible for driver role -->
    <router-link v-if="showKeyHandover" to="/key-handover" class="flex flex-col items-center text-xs relative group" active-class="text-[#E9041D]" exact-active-class="text-[#E9041D]">
      <div class="p-2 rounded-full transition-colors group-hover:bg-gray-100">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z" />
        </svg>
      </div>
      <span class="mt-1 font-medium">Schlüssel</span>
      <div class="absolute -top-1 -right-1 w-2 h-2 bg-[#E9041D] rounded-full" v-if="$route.path.startsWith('/key-handover')"></div>
    </router-link>
    
    <!-- Tasks - Only visible for disponent role -->
    <router-link v-if="showTasks" to="/tasks" class="flex flex-col items-center text-xs relative group" active-class="text-[#E9041D]" exact-active-class="text-[#E9041D]">
      <div class="p-2 rounded-full transition-colors group-hover:bg-gray-100">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
        </svg>
      </div>
      <span class="mt-1 font-medium">Tasks</span>
      <div class="absolute -top-1 -right-1 w-2 h-2 bg-[#E9041D] rounded-full" v-if="$route.path.startsWith('/tasks')"></div>
    </router-link>
    
    <!-- Standtage - Only visible for disponent role (DEV-137) -->
    <router-link v-if="showStanding" to="/standing-vehicles" class="flex flex-col items-center text-xs relative group" active-class="text-[#E9041D]" exact-active-class="text-[#E9041D]">
      <div class="p-2 rounded-full transition-colors group-hover:bg-gray-100">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      </div>
      <span class="mt-1 font-medium">Standtage</span>
      <div class="absolute -top-1 -right-1 w-2 h-2 bg-[#E9041D] rounded-full" v-if="$route.path.startsWith('/standing-vehicles')"></div>
    </router-link>

    <!-- Profil - Visible for all roles -->
    <router-link to="/profile" class="flex flex-col items-center text-xs relative group" active-class="text-[#E9041D]" exact-active-class="text-[#E9041D]">
      <div class="p-2 rounded-full transition-colors group-hover:bg-gray-100">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
        </svg>
      </div>
      <span class="mt-1 font-medium">Profil</span>
      <div class="absolute -top-1 -right-1 w-2 h-2 bg-[#E9041D] rounded-full" v-if="$route.path === '/profile'"></div>
    </router-link>
  </nav>
</template>

<script setup lang="ts">
import { useAuth } from '../composables/useAuth'
import { onMounted, ref, computed } from 'vue'

const { isChecker, isDriver, isDisponent, state, fetchUser } = useAuth()
const isLoading = ref(true)

// Navigation visibility follows the ACTIVE role (isDriver/isChecker/isDisponent
// read activeRole). Do NOT fall back to the user's primary role_name/role_id —
// that doesn't change on a role switch, which would show both roles' links.
const showChecks = computed(() => isChecker.value || isDisponent.value)
const showDrives = computed(() => isDriver.value)
const showKeyHandover = computed(() => isDriver.value)
const showTasks = computed(() => isDisponent.value)
const showStanding = computed(() => isDisponent.value)

onMounted(async () => {
  if (!state.value.user) {
    await fetchUser()
  }
  isLoading.value = false
})
</script> 